export default __webpack_public_path__ + "static/bg-ai-as-a-service--mobile-0a1c7b6e01eb1fee35aa16c8522e3fb6.jpg";